module.exports = __webpack_public_path__ + "img/jf7.2ef3feea.png";